import React from 'react';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { HeaderSelectWrapper } from '../../../components/HeaderSelectWrapper';
import { TextAreaEdit } from '../../../components/TextAreaEdit';
import { IElement } from '../../../models/Element';
import { STATUS_SERVICES, StatusUpdates } from './StatusUpdates';

interface Props {
  index: number;
  data: StatusUpdates;
  updateData: (body: IElement, index: number) => void;
}

/**
 * The block has no content of its own: the status updates are edited on
 * voys.nl and read live by the website. Only the heading, which services the
 * grid shows and whether the recent-updates list is hidden are set here.
 */
export const StatusUpdatesFC: React.FC<Props> = ({ index, data, updateData }) => {
  const update = (to: Partial<StatusUpdates>) => {
    updateData({ ...data, ...to }, index);
  };

  const services = data.services ?? [];

  const toggleService = (key: string, checked: boolean) => {
    const next = checked
      ? [...services.filter((service) => service !== key), key]
      : services.filter((service) => service !== key);

    update({ services: STATUS_SERVICES.map((s) => s.key).filter((k) => next.includes(k)) });
  };

  return (
    <ElementWrapper elementIndex={index}>
      <div className="status-updates body-my-8">
        <HeaderSelectWrapper name={'heading_type'} value={data.heading_type} setValue={update}>
          <TextAreaEdit className="heading" name={'heading'} value={data.heading} setValue={update} />
        </HeaderSelectWrapper>

        <div className="alert alert-secondary d-flex align-items-center my-5" role="note">
          <span>
            De statusupdates zelf worden beheerd op <strong>voys.nl</strong> (Status Manager) en hier live
            getoond. Vink daar <em>verbonden.nl</em> of <em>All websites</em> aan bij een update.
          </span>
        </div>

        <label className="form-label fw-bolder">Getoonde diensten</label>
        <div className="d-flex flex-wrap gap-6 mb-5">
          {STATUS_SERVICES.map((service) => (
            <div className="form-check form-check-custom form-check-solid" key={service.key}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`status-service-${index}-${service.key}`}
                checked={services.includes(service.key)}
                onChange={(event) => toggleService(service.key, event.target.checked)}
              />
              <label className="form-check-label" htmlFor={`status-service-${index}-${service.key}`}>
                {service.label}
              </label>
            </div>
          ))}
        </div>
        {services.length === 0 && (
          <div className="text-muted mb-5">Geen dienst aangevinkt: de website toont ze dan alle zes.</div>
        )}

        <div className="form-check form-check-custom form-check-solid">
          <input
            className="form-check-input"
            type="checkbox"
            id={`status-hide-overview-${index}`}
            checked={Boolean(data.hide_overview)}
            onChange={(event) => update({ hide_overview: event.target.checked })}
          />
          <label className="form-check-label" htmlFor={`status-hide-overview-${index}`}>
            Verberg het overzicht van recente updates
          </label>
        </div>
      </div>
    </ElementWrapper>
  );
};
